@if (optionsList.length) {
  <div
    role="radiogroup"
    [attr.aria-label]="groupAriaLabel || null"
    [attr.aria-disabled]="isGroupDisabled ? true : null"
    class="mot-radio-toggle-group !border-0 flex w-full"
    [class]="class"
    >
    <!-- div + role="radio": native <button> causes redundant "click" feedback with SR + arrows (APG uses non-button radios). -->
    @for (opt of optionsList; track opt; let i = $index) {
      <div
        #radioBtn
        role="radio"
        [attr.aria-checked]="isSelected(opt)"
        [attr.aria-disabled]="!!opt.disabled || isGroupDisabled ? true : null"
        [attr.tabindex]="tabIndexForOption(opt)"
        class="mot-radio-toggle font-bold text-sm"
        [class]="toggleClass"
        [class.mot-radio-toggle--checked]="isSelected(opt)"
        [class.mot-radio-toggle--disabled]="!!opt.disabled || isGroupDisabled"
        (click)="selectOption(opt)"
        (keydown)="onRadioKeydown($event, i)"
        >
        {{ opt.label }}
      </div>
    }
  </div>
}
